<template>
    <div class="mb-xl">
        <span class="font-regular text-neutral-dark text-sm">
            {{ label }} <span v-if="!required">- {{ lang('frivilligt','optional') }}</span>
        </span>
        <label class="file-input" :class="{ 'is-over': over }">
            <input
                ref="fileUpload"
                type="file"
                :name="name"
                :required="required"
                :disabled="disabled"
                :accept="accept"
                :multiple="multiple"
                @change="handleFileChange"
                @dragenter="over = true"
                @dragend="over = false"
                @dragleave="over = false"
                @drop="over = false"
            >
            <div class="flex flex-col md:flex-row md:items-center">
                <div class="btn btn-sm is-ghost md:mr-sm">{{ lang('Välj filer','Select files') }}</div>
                <div v-if="numberOfFiles > 1" class="mt-md md:mt-0">
                    {{ numberOfFiles }} {{ lang('filer valda','files selected') }}
                </div>
                <div v-else-if="numberOfFiles === 1" class="mt-md break-words md:mt-0">
                    {{ fileName }}
                </div>
                <div v-else class="hidden md:flex">
                    {{ lang('eller dra och släpp filer här','or drag and drop your files here') }}.
                </div>
            </div>
        </label>

        <div v-if="description" class="form-description">
            {{ description }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            required: {
                required: false,
                type: Boolean,
                default: false,
            },
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            },
            name: {
                required: false,
                type: String,
                default: 'attachments[]',
            },
            label: {
                required: true,
                type: String,
                default: null,
            },
            multiple: {
                required: false,
                type: Boolean,
                default: true,
            },
            accept: {
                required: false,
                type: String,
                default: 'image/png, image/jpeg, image/gif, application/pdf, text/plain',
            },
            description: {
                required: false,
                type: String,
                default: null,
            },
        },
        data() {
            return {
                files: [],
                numberOfFiles: 0,
                fileName: null,
                over: false,
            };
        },
        methods: {
            handleFileChange() {
                if (! this.$refs.fileUpload) {
                    this.numberOfFiles = 0;
                    this.fileName = null;
                }

                this.numberOfFiles = this.$refs.fileUpload.files.length;
                this.fileName = this.$refs.fileUpload.files[0].name;

            },
        },
    };
</script>
